import React from 'react';
import { ApolloProvider as HooksProvider } from '@apollo/react-hooks';
import { apolloService } from '../services';

/* -------------------------------------------------------------------------- *
 * ApolloProvider
 *
 * Powers Apollo hooks throughout the application.
 * -------------------------------------------------------------------------- */
export const ApolloProvider = ( { children } ) => (
    <HooksProvider client={ apolloService } children={ children } />
);
